export const EyeOpen = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="white"
    className="h-5 w-5 appearance-none border-0 bg-transparent shadow-none outline-none"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.25 12s3.75-7.5 9.75-7.5S21.75 12 21.75 12s-3.75 7.5-9.75 7.5S2.25 12 2.25 12z"
    />
    <circle cx="12" cy="12" r="3" />
  </svg>
)

export const EyeClosed = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="white"
    className="h-5 w-5 appearance-none border-0 bg-transparent shadow-none outline-none"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 3l18 18" />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.58 10.58A3 3 0 0012 15a3 3 0 002.42-4.42M6.71 6.71C4.23 8.3 2.25 12 2.25 12s3.75 7.5 9.75 7.5c1.55 0 2.98-.3 4.23-.82"
    />
  </svg>
)
